import { render } from "./StateBudgetList.vue?vue&type=template&id=dd2eef0a&scoped=true"
import script from "./StateBudgetList.vue?vue&type=script&lang=js"
export * from "./StateBudgetList.vue?vue&type=script&lang=js"

import "./StateBudgetList.vue?vue&type=style&index=0&id=dd2eef0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2eef0a"]])

export default __exports__